<template>
  <base-popup
    class="bills-registry-format-popup"
    ref="popup"
    :without-icon="true"
  >
    <template #content>
      <div class="bills-registry-format-popup__title">
        {{ $t('bills.popup.by-registry-format.title') }}
      </div>
      <div
        class="bills-registry-format-popup__points"
        v-html="$t('bills.popup.by-registry-format.points')"
      ></div>
      <div class="bills-registry-format-popup__ex-title">
        {{ $t('bills.popup.by-registry-format.example-title') }}
      </div>
      <div class="bills-registry-format-popup__ex-image">
        <img :src="exampleIcon" alt="bills registry example" />
      </div>
    </template>
    <template #actions="{ close }">
      <div class="bills-registry-format-popup__actions">
        <primary-button
          class="bills-registry-format-popup__actions-item"
          @click="downloadExample"
          :label="$t('bills.popup.by-registry-format.actions.download-example')"
        ></primary-button>
        <no-bg-button
          class="bills-registry-format-popup__actions-item"
          @click="close"
          :label="$t('bills.popup.by-registry-format.actions.close')"
        ></no-bg-button>
      </div>
    </template>
  </base-popup>
</template>

<script>
import BasePopup from '@vue-app/components/base/popup/BasePopup.vue'
import PrimaryButton from '@vue-app/components/base/button/PrimaryButton.vue'
import NoBgButton from '@vue-app/components/base/button/NoBgButton.vue'
import { downloadBlob } from '@js-app/services/helpers/download'
import { mapState } from 'vuex'

export default {
  name: 'BillRegistryFormatPopup',
  components: { NoBgButton, PrimaryButton, BasePopup },

  EXAMPLE_DATA: [
    [
      'Дуга Олег Олександрович',
      '380999999999',
      'example@gmail.com',
      '4149571279372381',
      'Страховий внесок',
      '2000',
    ],
    [
      'Міщенко Оксана Євгенівна',
      '380999999999',
      'example@gmail.com',
      '4149571279372381',
      'Страховий внесок',
      '2000',
    ],
    [
      'Лотузь Тетяна Володимирівна',
      '380999999999',
      'example@gmail.com',
      '4149571279372381',
      'Страховий внесок',
      '2000',
    ],
  ],

  methods: {
    open() {
      return this.$refs.popup.open()
    },
    downloadExample() {
      fetch('/docs/examples/xpay-bill-exemple.xlsx')
        .then((response) => response.blob())
        .then((blob) => {
          downloadBlob(blob, 'bill-registry-example.xlsx')
        })
    },
  },
  computed: {
    locale() {
      let lang = this.$i18n?.locale ?? 'en'
      return lang === 'uk' ? 'ua' : lang
    },

    exampleIcon() {
      return `/images/bill-registry-example-${this.locale}.png`
    },
  },
}
</script>

<style lang="scss" scoped>
.bills-registry-format-popup {
  :deep(.popup) {
    max-width: 840px;
    width: 100%;
    padding: 53px 90px 35px;

    .popup__actions {
      margin-top: 14px;
    }
  }

  &__title {
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    align-items: center;
    color: #27365b;
    margin-bottom: 32px;
  }

  &__points {
    font-weight: 400;
    font-size: 10px;
    line-height: 16px;
    text-align: left;
    color: #67768a;
    margin-bottom: 22px;
  }

  &__ex-title {
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
    color: #27365b;
    margin-bottom: 10px;
  }

  &__ex-image {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
    }
  }

  &__actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &-item {
      padding: 13px 35px;
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
